var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('EntityMap',{attrs:{"transceivers":_vm.transceivers,"entityLocations":_vm.feedTankLocations,"mapcenter":_vm.mapCenter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }